
import TextBlock from '~/components/ui/TextBlock.vue'
import ProductToolsRound from '~/components/products/ProductToolsRound.vue'
import ProductToolsRound3 from '~/components/products/ProductToolsRound3.vue'
import ProductToolsRound4 from '~/components/products/ProductToolsRound4.vue'
import ProductToolsRound5 from '~/components/products/ProductToolsRound5.vue'
import ProductToolsRound10 from '~/components/products/ProductToolsRound10.vue'
import PreHead from '~/components/ui/PreHead.vue'
export default {
  props: {
    connectedTools: {
      type: Array,
      required: true
    },
    product: {
      type: Object,
      required: false
    }
  },
  components: {
    TextBlock,
    ProductToolsRound,
    ProductToolsRound3,
    ProductToolsRound4,
    ProductToolsRound5,
    ProductToolsRound10,
    PreHead
  }
}
